// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_qt-5";
export var filledCircle = "_qt-4";
export var historyEntry = "_qt-3";
export var messageSideLeft = "_qt-1";
export var messageSideRight = "_qt-2";
export var orderTrackingCarouselWrapper = "_qt-6";
export var orderTrackingInfoContainer = "_qt-0";